import React from 'react'

/** Figma Group 1 — desktop glow (tüm container) */
const DesktopGlowBg: React.FC = () => (
  <svg
    width="1176"
    height="478"
    viewBox="0 0 1176 478"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    preserveAspectRatio="xMidYMid slice"
  >
    <g filter="url(#pf_glow_filter0)">
      <path
        d="M307.3 550.329C927.336 550.329 1221.26 361.717 1221.26 106.213C1221.26 -149.291 654.387 -113.729 446.763 106.213C321.974 238.405 -312.735 550.329 307.3 550.329Z"
        fill="url(#pf_glow_paint0)"
        fillOpacity="0.2"
      />
    </g>
    <g filter="url(#pf_glow_filter1)">
      <ellipse
        cx="827.448"
        cy="430.93"
        rx="149.653"
        ry="43.9973"
        transform="rotate(-7.11344 827.448 430.93)"
        fill="#7340E6"
      />
    </g>
    <defs>
      <filter
        id="pf_glow_filter0"
        x="-200.759"
        y="-312.781"
        width="1662.47"
        height="1103.56"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="120.226" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="pf_glow_filter1"
        x="534.573"
        y="239.218"
        width="585.75"
        height="383.425"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="72.1358" result="effect1_foregroundBlur" />
      </filter>
      <radialGradient
        id="pf_glow_paint0"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(630.477 65.5764) rotate(90) scale(484.753 919.877)"
      >
        <stop offset="0.100962" stopColor="#F4EFFF" />
        <stop offset="0.533654" stopColor="#9966FF" />
        <stop offset="0.878125" stopColor="white" />
      </radialGradient>
    </defs>
  </svg>
)

export default DesktopGlowBg
